<template>
  <div>
    <AccountLink />
    <AccountLink
      link-text="My Account - Sign in or Register"
      is-mobile-only
      mounting-point-selector="[data-js='mobile-nav-login-link']"
      :during-rewards-experience="duringRewardsExperience"
    />
  </div>
</template>

<script>
import { AccountLink } from '@rei/account-flyout';

export default {
  name: 'AccountLinkFragment',
  components: {
    AccountLink,
  },
  props: {
    duringRewardsExperience: {
      type: String,
      default: 'control',
    },
  },
};
</script>
